import { useQuery } from '@tanstack/react-query';

import { RoleAssignmentService } from '@/features/role-assignments/services';
import { QUERY_KEYS } from '@/constants';

export const useRoleAssignmentDetailsQuery = (id?: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.roleAssignment(id || ''),
    queryFn: async () => {
      const response = await RoleAssignmentService.GetRoleAssignment(id || '');
      return response.data;
    },
    enabled: !!id,
  });
};
